import { combineReducers } from 'redux'
import login from './login'
import pages from './pages'

export default combineReducers({
  login,
  pages
})